// extracted by mini-css-extract-plugin
module.exports = {"blinking":"customOption_blinking__LEcGr","blinkOption":"customOption_blinkOption__JqI4x"};